/** 権限のない画面をURL直打ちで開かれた場合の防波堤(実際の防御はセキュリティルール) */
import type { ReactNode } from 'react';

export default function RequirePermission({
  allowed,
  children,
}: {
  allowed: boolean;
  children: ReactNode;
}) {
  if (allowed) return <>{children}</>;
  return (
    <section className="screen">
      <div className="card">
        <h3>この画面を開く権限がありません</h3>
        <p className="hint">
          必要な場合は管理者(本部)に権限の付与を依頼してください。
        </p>
      </div>
    </section>
  );
}
